import {
  REGISTRATION,
  CONFIRM_REGISTRATION,
  RESET_REGISTRATION,
  LOGOUT
} from '../constants/ActionTypes';
import {
  _PENDING,
  _REJECTED,
  _FULFILLED
} from '../constants/PromiseMiddleware';

const defaultStore = {
  fetching: false, // for loading signup and confirm buttons
  isRegistrationConfirmed: false, // [boolan] that represents whether registration is confirmed
  isRegistrated: false, // [boolean] that represents whether signup form has been submitted successfully
  newUser: {}
};

//   NOTE:  *_PENDING, *_FULFILLED and  *_REJECTED , are triggered by the promise-middleware
const registration = (state = defaultStore, action) => {
  switch (action.type) {
    case LOGOUT:
      return defaultStore;

    // Registration call
    case REGISTRATION:
      return { ...state };

    // Waiting for async Registration response
    case REGISTRATION + _PENDING:
      return { ...state, fetching: true };

    // Registration successfully
    case REGISTRATION + _FULFILLED:
      return {
        ...state,
        isRegistrated: true,
        fetching: false,
        newUser: action.payload
      };

    // Error while registrating
    case REGISTRATION + _REJECTED:
      return { ...state, fetching: false };

    case RESET_REGISTRATION:
      return { ...state, isRegistrated: false };

    // Confirm Registration call
    case CONFIRM_REGISTRATION:
      return { ...state };

    // Waiting for async Confirm Registration response
    case CONFIRM_REGISTRATION + _PENDING:
      return { ...state, fetching: true };

    // Confirm Registration successfully
    case CONFIRM_REGISTRATION + _FULFILLED:
      return { ...state, fetching: false, isRegistrationConfirmed: true };

    // Error while confirming Registration
    case CONFIRM_REGISTRATION + _REJECTED:
      return { ...state, fetching: false };

    default:
      return state;
  }
};

module.exports = registration;



// WEBPACK FOOTER //
// ./reducers/registrationReducer.js